import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Header } from "../components/Common/Header";
import workshops from "../data/Workshops/Workshops.json";

import SharePostButton from "../components/Common/SharePost";
import ICFblogs from "../data/Blogs/ICF.json";
import { trendingblogs } from "../data/Blogs/BlogPosts";

export const SingleBlog = () => {
  const { id } = useParams();

  const location = useLocation();
  const fullUrl =
    window.location.origin +
    location.pathname +
    location.search +
    location.hash;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let workshop = workshops.find((workshop) => workshop.id === id);

  if (!workshop) {
    workshop = trendingblogs.find((workshop) => workshop.id === id);
  }

  if (!workshop) {
    workshop = ICFblogs.find((workshop) => workshop.id === id);
  }

  function parseWithBold(text) {
    const parts = text.split(/(\*{1,3}.*?\*{1,3})/); // Match *, **, or *** wrapped text
  
    return parts.map((part, index) => {
      if (part.startsWith("***") && part.endsWith("***")) {
        return (
          <span key={index} style={{ fontSize: '2rem', fontWeight: 'bold' }}>
            {part.slice(3, -3)}
          </span>
        );
      } else if (part.startsWith("**") && part.endsWith("**")) {
        return (
          <span key={index} style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            {part.slice(2, -2)}
          </span>
        );
      } else if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <strong key={index}>
            {part.slice(1, -1)}
          </strong>
        );
      }
      return part;
    });
  }  

  if (workshop) {
    return (
      <>
        <Header image={workshop.image} title={workshop.title} />
        <div
          style={{
            padding: "50px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <img
            src={workshop.image}
            alt={workshop.title}
            style={{ width: "100%"}}
          />
          {workshop.date &&
            workshop.time &&
            workshop.venue &&
            workshop.location && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "30px",
                  padding: "30px 0px",
                  paddingBottom: workshop.language ? 0 : "inherit",
                }}
              >
                {workshop.date && workshop.time && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                    }}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/833/833593.png"
                      alt={workshop.title}
                      width={50}
                      height={50}
                    />
                    <div>
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          textAlign: "left",
                          lineHeight: "1.6",
                        }}
                      >
                        {workshop.date}
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          textAlign: "left",
                          lineHeight: "1.6",
                        }}
                      >
                        {workshop.time}
                      </p>
                    </div>
                  </div>
                )}
                {workshop.venue && workshop.location && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                    }}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/535/535239.png"
                      alt={workshop.title}
                      width={50}
                      height={50}
                    />
                    <div>
                      <p
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          textAlign: "left",
                          lineHeight: "1.6",
                        }}
                      >
                        {workshop.venue}
                      </p>
                      <p
                        style={{
                          fontSize: "16px",
                          textAlign: "left",
                          lineHeight: "1.6",
                        }}
                      >
                        {workshop.location}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}

          {workshop.language && workshop.classSize && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                // justifyContent: "center",
                gap: "30px",
                padding: "30px 0px",
                paddingTop: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/128/484/484633.png"
                  alt={workshop.title}
                  width={50}
                  height={50}
                />
                <div>
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      textAlign: "left",
                      lineHeight: "1.6",
                    }}
                  >
                    Language
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      textAlign: "left",
                      lineHeight: "1.6",
                    }}
                  >
                    {workshop.language}
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                }}
              >
                <img
                  src="https://cdn-icons-png.flaticon.com/128/33/33308.png"
                  alt={workshop.title}
                  width={50}
                  height={50}
                />
                <div>
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      textAlign: "left",
                      lineHeight: "1.6",
                    }}
                  >
                    Class Size
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      textAlign: "left",
                      lineHeight: "1.6",
                    }}
                  >
                    {workshop.classSize}
                  </p>
                </div>
              </div>
            </div>
          )}
          <p style={{ fontSize: "40px", textAlign: "left" }}>
            {workshop.title}
          </p>
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6",
              whiteSpace: "pre-wrap",
            }}
          >
            {parseWithBold(workshop.description)}
          </p>
          {workshop.moreimages &&
            workshop.moreimages.map((imgObj, index) => (
              <div style={{ width: "100%" }}>
                <a href={imgObj.image} target="_blank" rel="noreferrer" style={{ width: "100%" }}>
                  <img
                    key={index}
                    src={imgObj.image}
                    alt=""
                    style={{ width: "100%", height: "auto" }}
                  />
                </a>
              </div>
            ))}
          {workshop.conclusion && (
            <div
              style={{
                boxShadow: "0px 4px 20px 0px #00000010",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "20px",
                borderRadius: "8px",
                borderLeft: "5px solid #107988",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  textAlign: "left",
                  lineHeight: "1.6",
                  fontWeight: "bold",
                  whiteSpace: "pre-wrap",
                }}
              >
                Conclusion
              </p>
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  lineHeight: "1.6",
                  whiteSpace: "pre-wrap",
                }}
              >
                {workshop.conclusion}
              </p>
            </div>
          )}
          <p
            style={{
              fontSize: "18px",
              textAlign: "left",
              lineHeight: "1.6",
              fontWeight: "bold",
              whiteSpace: "pre-wrap",
              display: "flex",
              alignItems: "center",
            }}
          >
            Share This Post :{" "}
            <SharePostButton title={workshop.title} url={fullUrl} />
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <Header
        image="https://media-public.canva.com/HpLL8/MAEFIYHpLL8/1/s2.jpg"
        title="Blog Posts"
      />
    </>
  );
};
